var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2651_1072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3427 7.44418C24.9156 7.81682 25.317 8.40178 25.4586 9.07038C25.5956 9.71726 25.4786 10.3911 25.1334 10.9531C22.2719 16.782 23.0307 25.2953 27.0177 31.1058L27.0217 31.1116C29.7083 35.087 35.083 39.7446 45.3886 38.8845L45.393 38.8841L48.0749 38.6363L41.5 33.5L45 29.5L56.1436 38.7136C56.6648 39.1555 58.212 40.4679 58.212 40.4679C58.212 40.4679 56.8853 41.8244 56.4435 42.3457L46.2594 54.3774L42.3075 51.0404L48.4821 43.7459L45.7936 43.9501L45.7897 43.9504C35.8975 44.7798 27.6685 41.2521 22.6942 33.958C17.6668 26.5887 16.7252 16.2118 20.4625 8.6065L20.5166 8.49624L20.8164 8.14119C21.1902 7.59927 21.758 7.22014 22.4037 7.08337C23.0723 6.94176 23.7698 7.07154 24.3427 7.44418Z",
    fill: "#256BE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3125 22C42.1042 22 41.0833 21.6014 40.25 20.8043C39.4167 20.0072 39 19.0308 39 17.875V4.125C39 2.9692 39.4167 1.99275 40.25 1.19565C41.0833 0.39855 42.1042 0 43.3125 0H57.6875C58.8958 0 59.9167 0.39855 60.75 1.19565C61.5833 1.99275 62 2.9692 62 4.125V17.875C62 19.0308 61.5833 20.0072 60.75 20.8043C59.9167 21.6014 58.8958 22 57.6875 22H43.3125Z",
    fill: "#256BE4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7586,
    cy: 50.2413,
    r: 11.7586,
    fill: "#012584"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2651_1072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card3.7b8dee5792745bb9399cf8624e88590a.svg";
export { ForwardRef as ReactComponent };